import { Component, OnInit } from '@angular/core';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { PledgeRead, Product } from '../../definition/interface/Pledge';

@Component({
    selector: 'lead-completion-subscription',
    templateUrl: './lead-completion-subscription.component.html',
    styleUrls: ['./lead-completion-subscription.component.scss'],
    standalone: false
})
export class LeadCompletionSubscriptionComponent implements OnInit {
  pledge: PledgeRead;
  products: Product[];

  constructor(private subscriptionFacade: SubscriptionFacadeService) {}

  ngOnInit(): void {
    this.pledge = this.subscriptionFacade.getPledge();
    this.products = this.pledge.products;
    this.products[0].parameters.sendCompletionSubscription = false;
  }

  next() {
    this.subscriptionFacade.nextStep();
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }

  sendCompletionSubscription() {
    this.products[0].parameters.sendCompletionSubscription = true;
  }
}
